import { render, staticRenderFns } from "./FAQReportExport.vue?vue&type=template&id=3c403878&scoped=true&"
import script from "./FAQReportExport.vue?vue&type=script&lang=js&"
export * from "./FAQReportExport.vue?vue&type=script&lang=js&"
import style0 from "./FAQReportExport.vue?vue&type=style&index=0&id=3c403878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c403878",
  null
  
)

export default component.exports